













import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SkipLink extends Vue {
  handleSkip() {
    const element = document.querySelector('#main-content');
    if (element) {
      // Set focus to the target element
      (element as HTMLElement).focus();
      // Emit event for parent components
      this.$emit('skip', element);
    }
  }
}
